import { Component, Input, OnInit } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { JobServicesService } from '../services/job-services.service';
import { saveAs } from 'file-saver';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SharedServicesService } from '../services/shared-services.service';

@Component({
    selector: 'app-job-list',
    templateUrl: './job-list.component.html',
    styleUrls: ['./job-list.component.css'],
    providers: [MessageService],
    standalone: false
})

export class JobListComponent implements OnInit {
  constructor(
    private jobService: JobServicesService,
    private messageService: MessageService,
    private _router: Router,
    private _sharedService: SharedServicesService,
  ) {
    
  }

  columnSettings: FormGroup = new FormGroup({
    columnName: new FormControl(''),
  })

  ngOnInit(): void {
  }

}
